import { useMemo } from 'react';

// There was some wonkiness around scrolling the sidebar when it was collapsed, depending
// on whether or not scrollbars are always visible for the client. This hook is used to
// adjust the sidebar width when scrollbars are always visible.
// More context: https://github.com/customerio/hydra/pull/1329
export const useScrollbarWidth = () => {
  return useMemo(() => {
    // create a temporary element with a forced scrollbar
    const outerElement = document.createElement('div');
    outerElement.style.visibility = 'hidden';
    outerElement.style.overflow = 'scroll';
    document.body.appendChild(outerElement);

    const innerElement = document.createElement('div');
    outerElement.appendChild(innerElement);

    // delta between outer and inner element width is scrollbar width
    const scrollbarWidth = outerElement.offsetWidth - innerElement.offsetWidth;

    // clean up
    outerElement.parentNode?.removeChild(outerElement);

    return scrollbarWidth;
  }, []);
};
